import { ChangeDetectionStrategy, Component, input, output, WritableSignal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { LookupType } from '../../../../core';

@Component({
  selector: 'lib-interactive-pill',
  imports: [MatIcon],
  templateUrl: './interactive-pill.component.html',
  styleUrl: './interactive-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractivePillComponent {
  titleText = input.required<string>();
  selected = input<boolean>(false);
  disabled = input<boolean>(false);
  showCross = input<boolean>(false);
  pillClick = output<void>();
}

export class InteractivePill {
  constructor(
    public lookupType: LookupType,
    public signal: WritableSignal<boolean>,
  ) {}

  toggleSignal() {
    this.signal.update(value => !value);
  }
}
